import { Modifier } from '@apollo/client/cache/core/types/common';

export const loadedAvatarCache = new Map<string, boolean>();

export const searchTeamMembersGroupsPopperModifiers:
  | readonly Partial<Modifier<unknown | object>>[]
  | undefined = [
  {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn({
      state,
    }: {
      state: {
        rects: { reference: { width: number } };
        styles: { popper: { minWidth: string; maxWidth: string; width: string } };
      };
    }): void {
      // Match dropdown width to input field width
      const width = state.rects.reference.width;
      state.styles.popper.width = `${width}px`;
      state.styles.popper.minWidth = `${width}px`;
      state.styles.popper.maxWidth = `${width}px`;
    },
    effect({
      state,
      instance,
    }: {
      state: {
        elements: {
          reference: HTMLElement;
          popper: { style: { width: string; minWidth: string; maxWidth: string } };
        };
      };
      instance: { update: () => void };
    }): () => void {
      const width = state.elements.reference.offsetWidth;
      state.elements.popper.style.width = `${width}px`;
      state.elements.popper.style.minWidth = `${width}px`;
      state.elements.popper.style.maxWidth = `${width}px`;

      const resizeObserver = new ResizeObserver(() => {
        instance.update();
      });
      resizeObserver.observe(state.elements.reference);

      return () => {
        resizeObserver.disconnect();
      };
    },
  },
];
